/* 
On loading single loadPassportRoute for transfer process
params passportId : id of the reciept
*/
export const loadPassportRoute = (passportId, callback) => {
    return dispatch => {
      dispatch({
        type: 'FETCH_PASSPORT_STEPS',
        passportId,
        callback
      })
    }
}


/* 
On loading single loadPassportRoute for transfer process
params passportId : reciept data
*/
export const loadPassportRouteSuccess = (data) => {
    return dispatch => {
      dispatch({
        type: 'FETCH_PASSPORT_STEPS_SUCCESS',
        data
      })
    }
}


/* 
On loadPassportRoute fail action
params passportId : reciept data
*/
export const loadPassportRouteFail = (passportId, errors) => {
    return dispatch => {
      dispatch({
        type: 'FETCH_PASSPORT_STEPS_FAIL',
        passportId,
        errors
      })
    }
}


/* 
On adding step data request for a product route
params data : step data
*/
export const addStep = (data) => {
  return dispatch => {
    dispatch({
      type: 'ADD_PASSPORT_STEP',
      data
    })
  }
}


/* 
On success of adding step data request for a product route
params data : step data
*/
export const addStepSuccess = (step) => {
  return dispatch => {
      dispatch({
          type: 'ADD_PASSPORT_STEP_SUCCESS',
          step
      })
  }
}


/* 
On failing of adding step data request for a product route
params errors    : errors
*/
export const addStepFail = (errors) => {
  return dispatch => {
      dispatch({
          type: 'ADD_PASSPORT_STEP_FAIL',
          errors
      })
  }
}


/* 
On updating step data request for a product route
params data : step data
*/
export const updateStep = (id, data) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_PASSPORT_STEP',
      id,
      data
    })
  }
}


/* 
On success of updating step data request for a product route
params data : step data
*/
export const updateStepSuccess = (id, step) => {
  return dispatch => {
      dispatch({
          type: 'UPDATE_PASSPORT_STEP_SUCCESS',
          step,
          id
      })
  }
}


/* 
On failing of updating step data request for a product route
params errors    : errors
*/
export const updateStepFail = (id, errors) => {
  return dispatch => {
      dispatch({
          type: 'UPDATE_PASSPORT_STEP_FAIL',
          id,
          errors
      })
  }
}


/* 
On deleting step data
params id : step id
*/
export const deleteStep = (id, identifier) => {
  return dispatch => {
      dispatch({
          type: 'DELETE_PASSPORT_STEP',
          id,
          identifier
      })
  }
}


/* 
On success of deleting step data 
*/
export const deleteStepSuccess = (id) => {
  return dispatch => {
      dispatch({
          type: 'DELETE_PASSPORT_STEP_SUCCESS',
          id
      })
  }
}


/* 
On failing of deleting step data
params errors    : errors
*/
export const deleteStepFail = (id, errors) => {
  return dispatch => {
      dispatch({
          type: 'DELETE_PASSPORT_STEP_FAIL',
          id,
          errors
      })
  }
}


/* 
On deleting step data
params id : step id
*/
export const undoStep = (id, identifier) => {
  return dispatch => {
      dispatch({
          type: 'UNDO_PASSPORT_STEP',
          id,
          identifier
      })
  }
}


/* 
On success of undoing step data 
*/
export const undoStepSuccess = (id) => {
  return dispatch => {
      dispatch({
          type: 'UNDO_PASSPORT_STEP_SUCCESS',
          id
      })
  }
}


/* 
On failing of undoing step data
params errors    : errors
*/
export const undoStepFail = (id, errors) => {
  return dispatch => {
      dispatch({
          type: 'UNDO_PASSPORT_STEP_FAIL',
          id,
          errors
      })
  }
}


/* 
On publishing a product route
params identifier : identifier of product route
*/
export const publishRoute = (identifier) => {
  return dispatch => {
    dispatch({
      type: 'PUBLISH_ROUTE',
      identifier
    })
  }
}


/* 
On succes of publishing a product route
params identifier : of product route
*/
export const publishRouteSuccess = (identifier) => {
  return dispatch => {
      dispatch({
          type: 'PUBLISH_ROUTE_SUCCESS',
          identifier
      })
  }
}


/* 
On failure of publishing a product route
params identifier : of product route
     errors    : errors
*/
export const publishRouteFail = (identifier, errors) => {
  return dispatch => {
      dispatch({
          type: 'PUBLISH_ROUTE_FAIL',
          identifier,
          errors
      })
  }
}


/* 
On requesting step data
params identifier : identifier of product route
*/
export const requestStepData = (stepId, data) => {
  return dispatch => {
    dispatch({
      type: 'REQUEST_PASSPORT_STEP_DATA',
      stepId,
      data
    })
  }
}


/* 
On succes of requesting step data
params identifier : of product route
*/
export const requestStepDataSuccess = (stepId) => {
  return dispatch => {
      dispatch({
          type: 'REQUEST_PASSPORT_STEP_DATA_SUCCESS',
          stepId
      })
  }
}


/* 
On failure of requesting step data
params stepId : id of product step
     errors    : errors
*/
export const requestStepDataFail = (stepId, errors) => {
  return dispatch => {
      dispatch({
          type: 'REQUEST_PASSPORT_STEP_DATA_FAIL',
          stepId,
          errors
      })
  }
}


/* 
On updating step data request for a product route
params data : step data
*/
export const updateStepCords = (id, data) => {
return dispatch => {
  dispatch({
    type: 'UPDATE_PASSPORT_STEP_CORDS',
    id,
    data
  })
}
}


/* 
On success of updating step data request for a product route
params data : step data
*/
export const updateStepCordsSuccess = (id, step) => {
return dispatch => {
    dispatch({
        type: 'UPDATE_PASSPORT_STEP_CORDS_SUCCESS',
        step,
        id
    })
}
}


/* 
On failing of updating step data request for a product route
params errors    : errors
*/
export const updateStepCordsFail = (id, errors) => {
return dispatch => {
    dispatch({
        type: 'UPDATE_PASSPORT_STEP_CORDS_FAIL',
        id,
        errors
    })
}
}

/* 
On panning zooming a product route
params identifier : identifier of product route
*/
export const updateRoutePanZoom = (identifier, data) => {
return dispatch => {
  dispatch({
    type: 'UPDATE_PASSPORT_PAN_ZOOM',
    identifier,
    data
  })
}
}


/* 
On succes of panning zooming a product route
params identifier : of product route
*/
export const updateRoutePanZoomSuccess = (identifier) => {
return dispatch => {
    dispatch({
        type: 'UPDATE_PASSPORT_PAN_ZOOM_SUCCESS',
        identifier
    })
}
}


/* 
On failure of panning zooming a product route
params identifier : of product route
   errors    : errors
*/
export const updateRoutePanZoomFail = (identifier, errors) => {
return dispatch => {
    dispatch({
        type: 'UPDATE_PASSPORT_PAN_ZOOM_FAIL',
        identifier,
        errors
    })
}
}


/* 
On requesting to reset & send partner email
params identifier : identifier of partner
*/
export const resetPartnerPassword = (partnerId) => {
return dispatch => {
  dispatch({
    type: 'RESET_PARTNER_PASSWORD',
    partnerId
  })
}
}


/* 
On succes of requesting to reset & send partner email
params identifier : identifier of partner
*/
export const resetPartnerPasswordSuccess = (partnerId) => {
return dispatch => {
    dispatch({
        type: 'RESET_PARTNER_PASSWORD_SUCCESS',
        partnerId
    })
}
}


/* 
On failure of requesting to reset & send partner email
params identifier : identifier of partner
errors    : errors
*/
export const resetPartnerPasswordFail = (partnerId, errors) => {
return dispatch => {
    dispatch({
        type: 'RESET_PARTNER_PASSWORD_FAIL',
        partnerId,
        errors
    })
}
}


/* 
On requesting to delete partner
params identifier : identifier of partner
*/
export const deletePartnerRequest = (partnerId) => {
return dispatch => {
  dispatch({
    type: 'DELETE_PARTNER_REQUEST',
    partnerId
  })
}
}


/* 
On succes of requesting to delete partner
params identifier : identifier of partner
*/
export const deletePartnerRequestSuccess = (partnerId) => {
return dispatch => {
    dispatch({
        type: 'DELETE_PARTNER_REQUEST_SUCCESS',
        partnerId
    })
}
}


/* 
On failure of requesting to delete partner
params identifier : identifier of partner
errors    : errors
*/
export const deletePartnerRequestFail = (partnerId, errors) => {
return dispatch => {
    dispatch({
        type: 'DELETE_PARTNER_REQUEST_FAIL',
        partnerId,
        errors
    })
}
}


/* 
On requesting certification for step data
params stepId : identifier of step
*/
export const applyForCertification = (stepId) => {
  return dispatch => {
    dispatch({
      type: 'APPLY_STEP_CERTIFICATION',
      stepId
    })
  }
}


/* 
On succes of requesting certification for step data
params stepId : of product route
*/
export const applyForCertificationSuccess = (stepId) => {
  return dispatch => {
      dispatch({
          type: 'APPLY_STEP_CERTIFICATION_SUCCESS',
          stepId
      })
  }
}


/* 
On failure of requesting certification for step data
params stepId : id of product step
     errors    : errors
*/
export const applyForCertificationFail = (stepId, errors) => {
  return dispatch => {
      dispatch({
          type: 'APPLY_STEP_CERTIFICATION_FAIL',
          stepId,
          errors
      })
  }
}


/* 
On certifiying the step
params stepId : identifier of step
*/
export const doCertify = (stepId, data) => {
  return dispatch => {
    dispatch({
      type: 'DO_CERTIFICATION',
      stepId,
      data
    })
  }
}


/* 
On succes of certifiying the step
params stepId : of product route
*/
export const doCertifySuccess = (stepId) => {
  return dispatch => {
      dispatch({
          type: 'DO_CERTIFICATION_SUCCESS',
          stepId
      })
  }
}


/* 
On failure of certifiying the step
params stepId : id of product step
     errors    : errors
*/
export const doCertifyFail = (stepId, errors) => {
  return dispatch => {
      dispatch({
          type: 'DO_CERTIFICATION_FAIL',
          stepId,
          errors
      })
  }
}


/* 
On acception the received asset
params stepId : identifier of step
*/
export const receiveAsset = (stepId, data) => {
  return dispatch => {
    dispatch({
      type: 'RECEIVE_ASSET',
      stepId,
      data
    })
  }
}


/* 
On succes of certifiying the step
params stepId : of product route
*/
export const receiveAssetSuccess = (stepId) => {
  return dispatch => {
      dispatch({
          type: 'RECEIVE_ASSET_SUCCESS',
          stepId
      })
  }
}


/* 
On failure of certifiying the step
params stepId : id of product step
     errors    : errors
*/
export const receiveAssetFail = (stepId, errors) => {
  return dispatch => {
      dispatch({
          type: 'RECEIVE_ASSET_FAIL',
          stepId,
          errors
      })
  }
}